const Countries = [
  { label: "ABD Küçük Harici Adaları", value: "UM" },
  { label: "ABD Virjin Adaları", value: "VI" },
  { label: "Afganistan", value: "AF" },
  { label: "Aland Adaları", value: "AX" },
  { label: "Almanya", value: "DE" },
  { label: "Amerika Birleşik Devletleri", value: "US" },
  { label: "Amerikan Samoası", value: "AS" },
  { label: "Andorra", value: "AD" },
  { label: "Angola", value: "AO" },
  { label: "Anguilla", value: "AI" },
  { label: "Antarktika", value: "AQ" },
  { label: "Antigua ve Barbuda", value: "AG" },
  { label: "Arjantin", value: "AR" },
  { label: "Arnavutluk", value: "AL" },
  { label: "Aruba", value: "AW" },
  { label: "Avustralya", value: "AU" },
  { label: "Avusturya", value: "AT" },
  { label: "Azerbaycan", value: "AZ" },
  { label: "Bahamalar", value: "BS" },
  { label: "Bahreyn", value: "BH" },
  { label: "Bangladeş", value: "BD" },
  { label: "Barbados", value: "BB" },
  { label: "Batı Sahra", value: "EH" },
  { label: "Belarus", value: "BY" },
  { label: "Belçika", value: "BE" },
  { label: "Belize", value: "BZ" },
  { label: "Benin", value: "BJ" },
  { label: "Bermuda", value: "BM" },
  { label: "Birleşik Arap Emirlikleri", value: "AE" },
  { label: "Birleşik Krallık", value: "GB" },
  { label: "Bolivya", value: "BO" },
  { label: "Bosna-Hersek", value: "BA" },
  { label: "Botsvana", value: "BW" },
  { label: "Bouvet Adası", value: "BV" },
  { label: "Brezilya", value: "BR" },
  { label: "Britanya Hint Okyanusu Toprakları", value: "IO" },
  { label: "Britanya Virjin Adaları", value: "VG" },
  { label: "Brunei", value: "BN" },
  { label: "Bulgaristan", value: "BG" },
  { label: "Burkina Faso", value: "BF" },
  { label: "Burundi", value: "BI" },
  { label: "Butan", value: "BT" },
  { label: "Cape Verde", value: "CV" },
  { label: "Cayman Adaları", value: "KY" },
  { label: "Cebelitarık", value: "GI" },
  { label: "Cezayir", value: "DZ" },
  { label: "Christmas Adası", value: "CX" },
  { label: "Cibuti", value: "DJ" },
  { label: "Cocos (Keeling) Adaları", value: "CC" },
  { label: "Cook Adaları", value: "CK" },
  { label: "Côte d’Ivoire", value: "CI" },
  { label: "Curaçao", value: "CW" },
  { label: "Çad", value: "TD" },
  { label: "Çekya", value: "CZ" },
  { label: "Çin", value: "CN" },
  { label: "Çin Hong Kong ÖİB", value: "HK" },
  { label: "Çin Makao ÖİB", value: "MO" },
  { label: "Danimarka", value: "DK" },
  { label: "Dominik Cumhuriyeti", value: "DO" },
  { label: "Dominika", value: "DM" },
  { label: "Ekvador", value: "EC" },
  { label: "Ekvator Ginesi", value: "GQ" },
  { label: "El Salvador", value: "SV" },
  { label: "Endonezya", value: "ID" },
  { label: "Eritre", value: "ER" },
  { label: "Ermenistan", value: "AM" },
  { label: "Estonya", value: "EE" },
  { label: "Esvatini", value: "SZ" },
  { label: "Etiyopya", value: "ET" },
  { label: "Falkland Adaları", value: "FK" },
  { label: "Faroe Adaları", value: "FO" },
  { label: "Fas", value: "MA" },
  { label: "Fiji", value: "FJ" },
  { label: "Filipinler", value: "PH" },
  { label: "Filistin", value: "PS" },
  { label: "Finlandiya", value: "FI" },
  { label: "Fildişi Sahili", value: "FS" },
  { label: "Fransa", value: "FR" },
  { label: "Fransız Guyanası", value: "GF" },
  { label: "Fransız Güney Toprakları", value: "TF" },
  { label: "Fransız Polinezyası", value: "PF" },
  { label: "Gabon", value: "GA" },
  { label: "Gambiya", value: "GM" },
  { label: "Gana", value: "GH" },
  { label: "Gine", value: "GN" },
  { label: "Gine-Bissau", value: "GW" },
  { label: "Grenada", value: "GD" },
  { label: "Grönland", value: "GL" },
  { label: "Guadeloupe", value: "GP" },
  { label: "Guam", value: "GU" },
  { label: "Guatemala", value: "GT" },
  { label: "Guernsey", value: "GG" },
  { label: "Guyana", value: "GY" },
  { label: "Güney Afrika", value: "ZA" },
  { label: "Güney Georgia ve Güney Sandwich Adaları", value: "GS" },
  { label: "Güney Kore", value: "KR" },
  { label: "Güney Sudan", value: "SS" },
  { label: "Gürcistan", value: "GE" },
  { label: "Haiti", value: "HT" },
  { label: "Heard Adası ve McDonald Adaları", value: "HM" },
  { label: "Hırvatistan", value: "HR" },
  { label: "Hindistan", value: "IN" },
  { label: "Hollanda", value: "NL" },
  { label: "Honduras", value: "HN" },
  { label: "Irak", value: "IQ" },
  { label: "İran", value: "IR" },
  { label: "İrlanda", value: "IE" },
  { label: "İspanya", value: "ES" },
  { label: "İsrail", value: "IL" },
  { label: "İsveç", value: "SE" },
  { label: "İsviçre", value: "CH" },
  { label: "İtalya", value: "IT" },
  { label: "İzlanda", value: "IS" },
  { label: "Jamaika", value: "JM" },
  { label: "Japonya", value: "JP" },
  { label: "Jersey", value: "JE" },
  { label: "Kamboçya", value: "KH" },
  { label: "Kamerun", value: "CM" },
  { label: "Kanada", value: "CA" },
  { label: "Karadağ", value: "ME" },
  { label: "Karayip Hollandası", value: "BQ" },
  { label: "Katar", value: "QA" },
  { label: "Kazakistan", value: "KZ" },
  { label: "Kenya", value: "KE" },
  { label: "GÜNEY KIBRIS RUM YÖNETİMİ", value: "KBB" },
  { label: "KUZEY KIBRIS TÜRK CUMHURİYETİ", value: "CY" },
  { label: "Kırgızistan", value: "KG" },
  { label: "Kiribati", value: "KI" },
  { label: "Kolombiya", value: "CO" },
  { label: "Komorlar", value: "KM" },
  { label: "Kongo - Brazavil", value: "CG" },
  { label: "Kongo - Kinşasa", value: "CD" },
  { label: "Kosta Rika", value: "CR" },
  { label: "Kosova (RS)", value: "KV" },
  { label: "Kuveyt", value: "KW" },
  { label: "Kuzey Kore", value: "KP" },
  { label: "Kuzey Makedonya", value: "MK" },
  { label: "Kuzey Mariana Adaları", value: "MP" },
  { label: "Küba", value: "CU" },
  { label: "Laos", value: "LA" },
  { label: "Lesotho", value: "LS" },
  { label: "Letonya", value: "LV" },
  { label: "Liberya", value: "LR" },
  { label: "Libya", value: "LY" },
  { label: "Liechtenstein", value: "LI" },
  { label: "Litvanya", value: "LT" },
  { label: "Lübnan", value: "LB" },
  { label: "Lüksemburg", value: "LU" },
  { label: "Macaristan", value: "HU" },
  { label: "Madagaskar", value: "MG" },
  { label: "Malavi", value: "MW" },
  { label: "Maldivler", value: "MV" },
  { label: "Malezya", value: "MY" },
  { label: "Mali", value: "ML" },
  { label: "Malta", value: "MT" },
  { label: "Man Adası", value: "IM" },
  { label: "Marshall Adaları", value: "MH" },
  { label: "Martinik", value: "MQ" },
  { label: "Mauritius", value: "MU" },
  { label: "Mayotte", value: "YT" },
  { label: "Meksika", value: "MX" },
  { label: "Mısır", value: "EG" },
  { label: "Mikronezya", value: "FM" },
  { label: "Moğolistan", value: "MN" },
  { label: "Moldova", value: "MD" },
  { label: "Monako", value: "MC" },
  { label: "Montserrat", value: "MS" },
  { label: "Moritanya", value: "MR" },
  { label: "Mozambik", value: "MZ" },
  { label: "Myanmar (Burma)", value: "MM" },
  { label: "Namibya", value: "NA" },
  { label: "Nauru", value: "NR" },
  { label: "Nepal", value: "NP" },
  { label: "Nijer", value: "NE" },
  { label: "Nijerya", value: "NG" },
  { label: "Nikaragua", value: "NI" },
  { label: "Niue", value: "NU" },
  { label: "Norfolk Adası", value: "NF" },
  { label: "Norveç", value: "NO" },
  { label: "Orta Afrika Cumhuriyeti", value: "CF" },
  { label: "Özbekistan", value: "UZ" },
  { label: "Pakistan", value: "PK" },
  { label: "Palau", value: "PW" },
  { label: "Panama", value: "PA" },
  { label: "Papua Yeni Gine", value: "PG" },
  { label: "Paraguay", value: "PY" },
  { label: "Peru", value: "PE" },
  { label: "Pitcairn Adaları", value: "PN" },
  { label: "Polonya", value: "PL" },
  { label: "Portekiz", value: "PT" },
  { label: "Porto Riko", value: "PR" },
  { label: "Reunion", value: "RE" },
  { label: "Romanya", value: "RO" },
  { label: "Ruanda", value: "RW" },
  { label: "Rusya", value: "RU" },
  { label: "Saint Barthelemy", value: "BL" },
  { label: "Saint Helena", value: "SH" },
  { label: "Saint Kitts ve Nevis", value: "KN" },
  { label: "Saint Lucia", value: "LC" },
  { label: "Saint Martin", value: "MF" },
  { label: "Saint Pierre ve Miquelon", value: "PM" },
  { label: "Saint Vincent ve Grenadinler", value: "VC" },
  { label: "Samoa", value: "WS" },
  { label: "San Marino", value: "SM" },
  { label: "Sao Tome ve Principe", value: "ST" },
  { label: "Senegal", value: "SN" },
  { label: "Seyşeller", value: "SC" },
  { label: "Sırbistan", value: "RS" },
  { label: "Sierra Leone", value: "SL" },
  { label: "Singapur", value: "SG" },
  { label: "Sint Maarten", value: "SX" },
  { label: "Slovakya", value: "SK" },
  { label: "Slovenya", value: "SI" },
  { label: "Solomon Adaları", value: "SB" },
  { label: "Somali", value: "SO" },
  { label: "Sri Lanka", value: "LK" },
  { label: "Sudan", value: "SD" },
  { label: "Surinam", value: "SR" },
  { label: "Suriye", value: "SY" },
  { label: "Suudi Arabistan", value: "SA" },
  { label: "Svalbard ve Jan Mayen", value: "SJ" },
  { label: "Şili", value: "CL" },
  { label: "Tacikistan", value: "TJ" },
  { label: "Tanzanya", value: "TZ" },
  { label: "Tayland", value: "TH" },
  { label: "Tayvan", value: "TW" },
  { label: "Timor-Leste", value: "TL" },
  { label: "Togo", value: "TG" },
  { label: "Tokelau", value: "TK" },
  { label: "Tonga", value: "TO" },
  { label: "Trinidad ve Tobago", value: "TT" },
  { label: "Tunus", value: "TN" },
  { label: "Turks ve Caicos Adaları", value: "TC" },
  { label: "Tuvalu", value: "TV" },
  { label: "Türkiye", value: "TR" },
  { label: "Türkmenistan", value: "TM" },
  { label: "Uganda", value: "UG" },
  { label: "Ukrayna", value: "UA" },
  { label: "Umman", value: "OM" },
  { label: "Uruguay", value: "UY" },
  { label: "Ürdün", value: "JO" },
  { label: "Vanuatu", value: "VU" },
  { label: "Vatikan", value: "VA" },
  { label: "Venezuela", value: "VE" },
  { label: "Vietnam", value: "VN" },
  { label: "Wallis ve Futuna", value: "WF" },
  { label: "Yemen", value: "YE" },
  { label: "Yeni Kaledonya", value: "NC" },
  { label: "Yeni Zelanda", value: "NZ" },
  { label: "Yunanistan", value: "GR" },
  { label: "Zambiya", value: "ZM" },
  { label: "Zimbabve", value: "ZW" },
];
export default Countries;
